import 'css-chunk:src/shared/Button.module.scss';export default {
  "button": "_button_1p08w_1",
  "sm": "_sm_1p08w_22",
  "lg": "_lg_1p08w_27",
  "ghost": "_ghost_1p08w_30",
  "link": "_link_1p08w_33"
};